<div id="mmc-performance-model">

  <div class="block">
    <div class="left">
      <label class="labelMmcPerf">
        Performance as-of date: @if (asOfDateRequired) {
        <span class="red">*</span>
      }
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="asOfDateTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #asOfDateTemplateRef>
        This is the date from which the performance numbers calculated below were derived.
      </ng-template>
    </label>
    <irb-dropdown-filter #IrbDropdownAsOfDate (search)="getAsOfDateLists($event) " size="12"
      [value]="selectedPerformanceAsOfDate"
      [disabled]="disableFields"
      hoverPanelWidth="150"
    (selection)="performanceAsOfChange($event)"></irb-dropdown-filter>
  </div>
  @if (toolTipShow) {
    <div class="tooltip shadow bottom">
      <div class="arrow"></div>
      <div id="tooltiptext" class="tooltiptext">
        Please select performance as-of date
      </div>
    </div>
  }
  <div class="left" style="margin-left: 40px;">
    <label class="labelMmcPerf" style="width: auto; margin-right: 10px;">
      GIPS-compliant:
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="gipsTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #gipsTemplateRef>
        Define whether the performance calculations you entered above for this model were from a GIPS-compliant
        composite of accounts or not.
      </ng-template>
    </label>
    <p-radioButton name="GIPS-compliant" [value]="true" [disabled]="disableFields"
      [(ngModel)]="data.gipsCompliant"
      (ngModelChange)="validateEntries()"
    inputId="mmperfmodelitem1"></p-radioButton>
    <label for="mmperfmodelitem1" [class.p-disabled]="disableFields">Yes</label>&nbsp;
    <p-radioButton name="GIPS-compliant" [value]="false" [disabled]="disableFields"
      [(ngModel)]="data.gipsCompliant"
      (ngModelChange)="validateEntries()"
    inputId="mmperfmodelitem2"></p-radioButton>
    <label for="mmperfmodelitem2" [class.p-disabled]="disableFields">No</label>&nbsp;
    <p-radioButton name="GIPS-compliant" [value]="'none'" [disabled]="disableFields"
      [(ngModel)]="data.gipsCompliant"
      (ngModelChange)="validateEntries()"
    inputId="mmperfmodelitem3"></p-radioButton>
    <label for="mmperfmodelitem3" [class.p-disabled]="disableFields">None</label>
  </div>
  <br class="clear"/>
</div>

<div class="block">
  <label class="labelMmcPerf" style="vertical-align: super;">
    Performance metrics:
    <span class="infoIcon"
    calltoaction [calltoactionTemplate]="metricsTemplateRef" calltoactionPosition="bottom"></span>
    <ng-template #metricsTemplateRef>
      <div style='width:300px; margin:2px;'>
        <div class="block">Enter your net return calculations from the performance as-of date for the
          following:
        </div>
        <div class="block note"><em><strong>Please Note:</strong> net returns data cannot include any
      hypothetical or back-tested results.</em></div>

      <div class="block">
        <div>1MO - Last month</div>
        <div>T3 - Trailing 3 months</div>
        <div>YTD - Year to date</div>
        <div>1YR - Trailing 1 year</div>
        <div>3YR - Trailing 3 years</div>
        <div>5YR - Trailing 5 years</div>
        <div>10YR - Trailing 10 years</div>
      </div>

      <div>As-of Inception Date</div>
      <div class="block">As-of Inception Return %</div>
      <div>Model Manager Performance Information:</div>
      <div>
        Performance information displayed on the Model Market Center (MMC) is not calculated, reviewed, or verified by either TD Ameritrade (TDA) or the MMC. Advisors are solely responsible for verifying the accuracy of any investment performance information provided through the MMC. TDA does not recommend the use of technical analysis as a sole means of investment research. MMC is not intended to be investment advice or a recommendation of any security. Investing in securities can be volatile and involves risk, including loss of principal. Consider your client’s individual circumstances.
      </div>
    </div>
  </ng-template>
</label>
<table class="tbl-performance-metrics">
  <tr>
    <td>1MO</td>
    <td>T3</td>
    <td>YTD</td>
    <td>1YR</td>
    <td>3YR</td>
    <td>5YR</td>
    <td>10YR</td>
  </tr>
  <tr>
    <td>
      <irb-number-text-box #meTxt [(value)]="data.me" min="-99999" max="99999" places="2"
        [disabled]="disableFields"
        class="mmc-perf-model-metrics" width="70px"
      (valueChange)="validateEntries()"></irb-number-text-box>
      %
    </td>
    <td>
      <irb-number-text-box #t3Txt [(value)]="data.t3" min="-99999" max="99999" places="2"
        [disabled]="disableFields"
        (valueChange)="validateEntries()"
      class="mmc-perf-model-metrics" width="70px"></irb-number-text-box>
      %
    </td>
    <td>
      <irb-number-text-box #yrdTxt [(value)]="data.ytd" min="-99999" max="99999" places="2"
        [disabled]="disableFields"
        (valueChange)="validateEntries()"
      class="mmc-perf-model-metrics" width="70px"></irb-number-text-box>
      %
    </td>
    <td>
      <irb-number-text-box #t12Txt [(value)]="data.t12" min="-99999" max="99999" places="2"
        [disabled]="disableFields"
        (valueChange)="validateEntries()"
      class="mmc-perf-model-metrics" width="70px"></irb-number-text-box>
      %
    </td>
    <td>
      <irb-number-text-box #yr3Txt [(value)]="data.yr3" min="-99999" max="99999" places="2"
        [disabled]="disableFields"
        (valueChange)="validateEntries()"
        class="mmc-perf-model-metrics" width="70px"
        invalidMessage="The value entered in not valid."
      invalidRangeMessage="The value entered in not valid."></irb-number-text-box>
      %
    </td>
    <td>
      <irb-number-text-box #yr5Txt [(value)]="data.yr5" min="-99999" max="99999" places="2"
        [disabled]="disableFields"
        (valueChange)="validateEntries()"
      class="mmc-perf-model-metrics" width="70px"></irb-number-text-box>
      %
    </td>
    <td>
      <irb-number-text-box #yr10Txt [(value)]="data.yr10" min="-99999" max="99999" places="2"
        [disabled]="disableFields"
        (valueChange)="validateEntries()"
      class="mmc-perf-model-metrics" width="70px"></irb-number-text-box>
      %
    </td>
  </tr>
</table>
</div>

<div class="block">
  <div class="left">
    <label class="labelMmcPerf" style="width: auto; margin-right: 10px;">
      As-of Inception Date: <span class="red">*</span>
    </label>
    <div class="mat-datepicker-container">
      <input matInput [max]="currentDate" [matDatepicker]="picker" class="date-control"
        [matDatepickerFilter]="inceptionDateFilter" [class]="!inceptionDateIsValid ? 'input-not-valid' : ''"
        [(ngModel)]="inceptionDate" (dateChange)="inceptionDateChange()" [disabled]="disableFields">
      <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="disableFields"></mat-datepicker-toggle>
      <mat-datepicker #picker [disabled]="disableFields"></mat-datepicker>
    </div>
  </div>
  <div class="left" style="margin-left: 10px;">
    <label class="labelMmcPerf" style="width: auto; margin: 5px 10px 0 10px;">
      As-of Inception Return:
    </label>
    <irb-number-text-box #rorInceptionTxt [(value)]="data.rorInception" min="-99999" max="99999" places="2"
      [disabled]="disableFields"
      (valueChange)="validateEntries()"
    class="mmc-perf-model-metrics" width="70px"></irb-number-text-box>
    %
  </div>
  <br class="clear"/>
</div>
</div>
